define((require) => {
    "use strict";

    const PublishUtil   = require("ui/publish/PublishUtil");
    const template      = require("ui/publish/channelSetup/ChannelBookmarklet.tpl");

    const VERSION = 2;

    return {

        fromId(id) {
            const mosaikHost = window.location.host;

            return template({
                id,
                // The absolute channel url is comprised on the *client* protocol + "mosaikHost" + pathname +
                // "channel.js" (see ChannelBookmarklet.tpl). This ensures that if the client site uses https,
                // the channel snippet will be loaded via https as well. creator.zmags.com works on both
                // https and http, so this should ensure that the channel snippet is loaded using the correct
                // protocol. However, this will *not* work locally or on development with a client site using
                // https, since we use only http there. Trying to embed the channel snippet code via http from
                // a https site will thus fail.
                channelUrl: PublishUtil.SNIPPET,
                mosaikHost,
                warning:    "Please click the button you added to the toolbar in your website window.",
                version:    VERSION // to ensure the user will be notified if we ever change the bookmarklet drastically!
            });
        },

        // The current version of the channel bookmarklet, used to ensure that clients will get notified if we
        // ever need to update the bookmarklet, i.e. re-drag it on the browser toolbar. Only change this value when the
        // bookmarklet code itself has changed in a manner that requires clients to upgrade it!
        VERSION
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/channelSetup/ChannelBookmarklet.js